import style from './../css/rootframe.module.css'

var RootFrame =({children})=>{

  return (
    <div style={{position: 'absolute', top: '0', left: '0', overflowY: 'auto', overflowX: 'hidden', width: '100%', height: 'calc(100 * var(--vh))', backgroundColor: "black"}}>
      {children}
    </div>
  )
}
export default RootFrame